<template lang="pug">
    d2-container
        el-form(:inline='true', :model='dataForm'  size='mini' label-width="80px" label-position='left' :modal-append-to-body='false'  label-suffix=':' )
            el-row(:span='24')
              el-col(:md='6' :sm="12")
                el-form-item(label="姓名" )
                    el-input.inputWidth(v-model='dataForm.mbName' clearable )
              el-col(:md='6' :sm="12")
                el-form-item(label="账号" )
                    el-input.inputWidth(v-model='dataForm.mobile' clearable )
              el-col(:md='6' :sm="12")
                el-form-item(label="培训名称" )
                    el-input.inputWidth(v-model='dataForm.name' clearable )
              el-col(:md='6' :sm="12")
                el-form-item(label="培训ID" )
                    el-input.inputWidth(v-model='dataForm.trainCode' clearable )
              el-col(:md='6' :sm="12")
                el-form-item(label="培训类别")
                    el-select.inputWidth(style='width:200px;' v-model='dataForm.type' clearable)
                      el-option(v-for="(e, i) in pxType" :key="i" :label="e.label" :value="e.value")
              el-col(:md='6' :sm="12")
                el-form-item(label="主办方")
                    el-select.inputWidth(style='width:200px;' v-model='dataForm.orgId' placeholder="请选择" filterable clearable)
                      el-option(v-for="(item,index) in sysOrgList",:key="index",:label="item.name",:value="item.orgId" )
        el-row(style="padding-bottom:15px;" :span="24")
            el-col(:md='23' :sm="5")
                el-button(@click='addOrUpdateHandle()'  type='primary'   v-if="isAuth('px:vacate:add')" ) 新建
                //- el-button(@click="deleteClick()"  type='danger'  v-if="isAuth('px:vacate:delete')" ) 删除
            el-col( :md='1' :sm="14" style='float:right;')
                el-button(@click='queryList()',type='primary',icon='el-icon-search',style='float:right;') 查 询
        el-table(:data="tableData" style="width: 100%" @selection-change="leaveDataChange" v-loading='dataListLoading' border)
            //- el-table-column(type='selection', header-align='center', align='center', width='50')
            el-table-column(prop='mbName',header-align='center',align='center',label='姓名')
            el-table-column(prop='mobile',header-align='center',align='center',label='账号')
            el-table-column(prop='trainCode',header-align='center',align='center',label='培训ID')
            el-table-column(prop='name',header-align='center',align='center',label='培训名称')
            el-table-column(prop='type',header-align='center',align='center',label='培训类别')
              template(slot-scope="scope")
                font(v-if="scope.row.type === '1'") 单次培训
                font(v-if="scope.row.type === '2'") 整期培训
                font(v-if="scope.row.type === '3'") 青少年儿童培训
                font(v-if="scope.row.type === '4'") 个人定制化
                font(v-if="scope.row.type === '5'") 团体定制化
            el-table-column(prop='orgName',header-align='center',align='center',label='主办方')
            el-table-column(prop='level',header-align='center',align='center',label='培训级别' width="80")
            el-table-column(prop='trainStrDate',header-align='center',align='center',label='培训开始时间')
            el-table-column(prop='isIssue',header-align='center',align='center',label='补课券' width="65")
              template(slot-scope="scope")
                font(v-if="scope.row.isIssue === 1") 未发放
                font(v-if="scope.row.isIssue === 2") 已发放
            el-table-column(prop='certificateUrl',header-align='center',align='center',label='凭证' width='80')
              template(slot-scope="scope")
                el-image(v-if="scope.row.certificateUrl" :src="scope.row.certificateUrl" :preview-src-list="[scope.row.certificateUrl]" style="width:40px;height:40px;" fit="cover" preview-teleported)
                span(v-else style="color:#909399;") 无
            el-table-column(prop='createTime',header-align='center',align='center',label='凭证提交时间' width='160')
            el-table-column(prop='auditStatus',header-align='center',align='center',label='审核状态' width='90')
              template(slot-scope="scope")
                el-tag(v-if="scope.row.auditStatus === 0" type="info" size="mini") 待审核
                el-tag(v-else-if="scope.row.auditStatus === 1" type="success" size="mini") 审核通过
                el-tag(v-else-if="scope.row.auditStatus === 2" type="danger" size="mini") 审核驳回
                span(v-else) -
            el-table-column(header-align='center',align='center',label='操作' width='110')
                    template(slot-scope="scope")
                      el-menu.menuPonit(@open="handleOpen" @close="handleClose" :collapse="isCollapse" )
                        el-submenu(index="1")
                            template(slot="title")
                                i(class="el-icon-more" style='color:#02B90D;')
                            el-menu-item-group()
                                //- el-menu-item(index="1-2" @click='deleteClick(scope.row.id)' :disabled="scope.row.isIssue == 2" v-if="isAuth('px:vacate:delete')" ) 删除
                                el-menu-item(index="1-3" @click='showTicket(scope.row)' :disabled="scope.row.isIssue == 2 || scope.row.auditStatus !== 1" v-if="isAuth('px:vacate:fang')" ) 发放补课券
                                el-menu-item(index="1-4" @click='auditHandle(scope.row)' :disabled="scope.row.auditStatus !== 0" v-if="isAuth('px:vacate:audit')" ) 审核
        el-pagination(@size-change='sizeChangeHandle', @current-change='currentChangeHandle', :current-page='pageIndex', :page-sizes='[10, 20, 50, 100]', :page-size='pageSize', :total='totalPage', layout='total, sizes, prev, pager, next, jumper')
        //- 添加和修改
        addOrUpdate(v-if='addOrUpdateVisible', ref="addOrUpdate",@refreshDataList='queryList')
        //- 审核弹窗
        el-dialog(title="审核" :visible.sync="auditDialogVisible" width='40%' :modal-append-to-body='false' :close-on-click-modal='false')
          el-form(:model="auditForm" :rules="auditRules" ref="auditForm" label-width="100px" label-position='left' @submit.native.prevent)
            el-form-item(label="姓名:")
                span {{ auditForm.mbName }}
            el-form-item(label="账号:")
                span {{ auditForm.mobile }}
            el-form-item(label="凭证:")
                el-image(v-if="auditForm.certificateUrl" :src="auditForm.certificateUrl" :preview-src-list="[auditForm.certificateUrl]" style="width:80px;height:80px;" fit="cover" preview-teleported)
                span(v-else style="color:#909399;") 无
            el-form-item(label="审核结果:" prop='auditStatus')
                el-radio-group(v-model='auditForm.auditStatus')
                    el-radio(:label='1')
                        | 通过
                    el-radio(:label='2')
                        | 驳回
            el-form-item(label="驳回原因:" prop='rejectReason' v-if="auditForm.auditStatus === 2")
                el-input(type="textarea" v-model="auditForm.rejectReason" :rows='4' resize='none' maxlength='200' show-word-limit)
            el-row(style='margin-top:20px;')
              el-col(align='center')
                el-button(type="primary" @click="auditSubmit()" :disabled="auditClickFlag") 确认
                el-button(@click="auditDialogVisible=false" style='margin-left:50px;') 取消
        //- 发放补课券
        el-dialog(title="发放补课券" :visible.sync="dialogFormVisible"  width='50%' :modal-append-to-body='false'  :close-on-click-modal='false')
          el-form(:model="ruleForm", :inline="false" :rules="rules", ref="ruleForm", label-width="120px",label-position='left' @submit.native.prevent)
            el-form-item(label="姓    名:" prop='name')
                el-input(type="text" v-model="ruleForm.name" readonly)
            el-form-item(label="会员账号:" prop='mobile')
                el-input(type="text" v-model="ruleForm.mobile" readonly)
            el-form-item(label="代金券类型:" prop='type')
                el-select(style='width:100%;' v-model="ruleForm.type")
                  el-option(label='补课券' :value='1' )
            el-form-item(label="使用范围(多选):" prop='rangeeSelect')
                el-select(style='width:100%;' v-model="ruleForm.rangeeSelect" multiple :remove-tag='removeTag')
                  el-option(v-for="item in rangeeArr" :key="item.value" :label="item.label" :value="item.value")
            el-form-item(label="有效期:" prop='couponDate')
                el-date-picker(v-model="ruleForm.couponDate" range-separator="至" type="daterange" start-placeholder="开始时间" end-placeholder="截止时间" :picker-options="pickerOptions" format="yyyy-MM-dd" value-format="yyyy-MM-dd" clearable)
            el-form-item(label='备注:' prop='remark')
                el-input(type="textarea" v-model="ruleForm.remark" :rows='5' resize='none')
            el-row(style='margin-top:30px;')
              el-col(align='center')
                el-button(type="primary" @click="ruleFormSubmit()" :disabled="clickFlag") 确认
                el-button(@click="dialogFormVisible=false" style='margin-left:50px;') 取消
</template>

<script>
import AddOrUpdate from './add-or-update'
import commonData from '../common.js'

export default {
  name: 'single',
  data () {
    return {
      clickFlag: false,
      dialogFormVisible: false,
      auditDialogVisible: false,
      auditClickFlag: false,
      auditForm: {
        id: null,
        mbName: '',
        mobile: '',
        certificateUrl: '',
        auditStatus: 1,
        rejectReason: ''
      },
      auditRules: {
        auditStatus: [
          { required: true, message: '请选择审核结果!', trigger: 'change' }
        ],
        rejectReason: [
          { required: true, message: '请输入驳回原因!', trigger: 'blur' },
          { max: 200, message: '驳回原因不能超过200个字符!', trigger: 'blur' }
        ]
      },
      isCollapse: true,
      loading: null,
      addOrUpdateVisible: false,
      elEnrollInfoVisible: false,
      leaveDataChangeList: '',
      rangeeArr: [
          { label: '分级单次培训', value: '1' },
          { label: '分级整期培训', value: '2' },
          { label: '青少年儿童培训', value: '3' },
          { label: '定制化培训', value: '4' }
      ],
      pickerOptions: {
          // disabledDate: time =>{
          //     return(
          //         time <= new Date()
          //     )
          // }
      },
      tableData: [],
      pxType: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      leaveId: '',
      matchStartTime: [],
      ruleForm: {
          id: null,
          code: '',
          type: 1,
          rangee: '',
          rangeeSelect: new Array(),
          couponDate: new Array(),
          startTime: null,
          endTime: null,
          remark: '',
          mbId: '',
          name: '',
          mobile: ''
      },
      dataForm: {
        mbName: '',
        mobile: '',
        name: '',
        trainCode: '',
        type: '',
        orgId: '' //主办方
      },
      sysOrgList: [],
      rules: {
          name: [
              { required: true, message: '会员姓名不能为空!', trigger: 'change' }
          ],
          mobile: [
              { required: true, message: '会员账号不能为空!', trigger: 'change' }
          ],
          type: [
              { required: true, message: '代金券类型不能为空!', trigger: 'change' }
          ],
          rangeeSelect: [
              { required: true, message: '使用范围不能为空!', trigger: 'change' }
          ],
          couponDate: [
              { required: true, message: '有效期不能为空!', trigger: 'change' }
          ],
          startTime: [
              { required: true, message: '有效开始日期不能为空!', trigger: 'change' }
          ],
          endTime: [
              { required: true, message: '有效结束日期不能为空!', trigger: 'change' }
          ],
          remark: [
              { max: 500, message: '备注不能超过500个字符!', trigger: 'blur' }
          ]
      }
    }
  },
  components: {
    AddOrUpdate
  },
  created () {
    this.pxType = commonData.pxType2
  },
  mounted () {
    this.getDataList()
    this.initCity()
  },
  methods: {
    removeTag () {

    },
    //操作三点
    handleOpen (key, keyPath) {
      console.log(key, keyPath)
    },
    handleClose (key, keyPath) {
      console.log(key, keyPath)
    },
    // 审核
    auditHandle (row) {
      this.auditForm = {
        id: row.id,
        mbName: row.mbName,
        mobile: row.mobile,
        certificateUrl: row.certificateUrl,
        auditStatus: 1,
        rejectReason: ''
      }
      this.auditDialogVisible = true
      this.$nextTick(() => {
        if (this.$refs.auditForm) this.$refs.auditForm.clearValidate()
      })
    },
    auditSubmit () {
      this.$refs['auditForm'].validate((valid) => {
        if (valid) {
          this.auditClickFlag = true
          this.$http({
            url: this.$http.adornUrl(`/pxLeave/audit`),
            method: 'post',
            data: {
              leaveId: this.auditForm.id,
              auditStatus: this.auditForm.auditStatus,
              rejectReason: this.auditForm.rejectReason
            }
          }).then(data => {
            this.auditClickFlag = false
            if (data && data.code === 0) {
              this.$message.success('审核成功!')
              this.auditDialogVisible = false
              this.getDataList()
            } else {
              this.$message.error(data.msg || '审核失败!')
            }
          }).catch(() => {
            this.auditClickFlag = false
            this.$message.error('请求错误')
          })
        }
      })
    },
    // 发放补课券
    showTicket (row) {
      this.leaveId = row.id
      this.ruleForm.name = row.mbName
      this.ruleForm.mobile = row.mobile
      this.ruleForm.mbId = row.memberId
      this.dialogFormVisible = true
    },
    //勾选列表事件
    leaveDataChange (val) {
      let list = []
      val.forEach(e => {
        list.push(e.id)
      })
      this.leaveDataChangeList = list.join()
    },
    deleteClick (ids) {
      if (!ids) {
        ids = this.leaveDataChangeList
      }
      if (!ids) {
        this.$message.warning('请选择需要删除的信息！')
        return
      }
      this.$confirm('请确认是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: this.$http.adornUrl(`/pxLeave/delete/` + ids),
          method: 'POST',
          params: this.$http.adornParams()
        }).then((data) => {
          if (data && data.code === 0) {
            this.$message.success('删除成功!')
            this.getDataList()
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    openFullScreen () {
      this.loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
    },
    //新增方法
    ruleFormSubmit () {
        this.$refs['ruleForm'].validate((valid) => {
            if (valid) {
                this.openFullScreen()
                this.clickFlag = true
                this.ruleForm.startTime = this.ruleForm.couponDate[0]
                this.ruleForm.endTime = this.ruleForm.couponDate[1]
                this.ruleForm.rangee = this.ruleForm.rangeeSelect.join(',')
                console.log('要提交的代金券：', this.ruleForm.rangee)
                this.$http({
                    url: this.$http.adornUrl(`/pbCoupon/save`),
                    method: 'post',
                    data: this.ruleForm
                }).then((data) => {
                   this.loading.close()
                    if (data && data.code === 0) {
                        this.$http({
                            url: this.$http.adornUrl(`/pxLeave/update`),
                            method: 'post',
                            data: {
                                id: this.leaveId,
                                isIssue: 2//补课卷是否发放(1=未发放，2=已发放)
                            }
                        }).then(data => {
                            this.loading.close()
                            console.log(data)
                            if (data && data.code === 0) {
                                this.$message({
                                    message: '操作成功',
                                    type: 'success',
                                    duration: 1500,
                                    onClose: () => {
                                        this.dialogFormVisible = false
                                        this.clickFlag = false
                                        this.getDataList()
                                    }
                                })
                            } else {
                                this.$message.success('添加失败!')
                                this.clickFlag = false
                            }
                        })
                    } else {
                        this.$message.error(data.msg)
                        this.clickFlag = false
                    }
                }).catch(e => {
                    this.$message.error('请求错误')
                    this.clickFlag = false
                })
            }
        })
    },

    queryList () {
      this.pageIndex = 1
      this.getDataList()
    },
    //添加或修改事件
    addOrUpdateHandle (id, flagType) {
      this.addOrUpdateVisible = true

      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id, flagType)
      })
    },
    getDataList () {
      this.dataListLoading = true
      this.dataForm.page = this.pageIndex
      this.dataForm.limit = this.pageSize
      this.$http({
        url: this.$http.adornUrl('/pxLeave/list'),
        method: 'post',
        data: this.dataForm
      }).then(data => {
        if (data && data.code === 0) {
          console.log(data,'data列表数据')
          this.tableData = data.page.records
          this.totalPage = data.page.total
        } else {
          this.tableData = []
          this.totalPage = 0
        }
        this.dataListLoading = false
      })
    },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getDataList()
    },
    initCity () {
      this.$http({
        url: this.$http.adornUrl('/sysOrg/list'),
        method: 'get'
      }).then(data => {
        this.sysOrgList = data && data.code === 0 ? data.list : []
      })
    }
  }
}
</script>
<style scoped>
/* 操作三点 菜单样式 */
@import "../../css/opr3dot.css";

.inputWidth {
  width: 200px;
}
.el-form--inline .el-form-item {
  display: inline-block;
  margin-right: 0px;
  vertical-align: top;
}

/* 提示框 */
.el-tooltip__popper.is-light {
  border: 1px solid #c0c4cc;
}

.el-tooltip__popper[x-placement^="bottom"] .popper__arrow {
  border-bottom-color: grey !important ;
}

.toolTip > p {
  margin: 0;
  padding-top: 10px;
  height: 14px;
  line-height: 14px;
  font-size: 14px;
  color: #606266;
}

.el-dialog {
    position: relative;
    margin: 0 auto 80px;
    border-radius: 2px;
    -webkit-box-shadow: 0 1px 3px rgba(0,0,0,.3);
    box-shadow: 0 1px 3px rgba(0,0,0,.3);
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 50%;
}
</style>
